import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import styles from "./header.module.scss"
import FirebaseAuth from "../../config/firebase"
import {
  setSubscription,
  setUser,
  selectUser,
  selectSubscription
} from "../../slices/authSlice"
import { useSelector, useDispatch } from "react-redux"

const Header = ({ siteTitle }) => {
  const [open, setOpen] = useState(false)
  const user = useSelector(selectUser)

  const toggleClass = () => {
    setOpen(!open)
  }

  const removeClass = () => {
    setOpen(false)
  }

  function signOut(e) {
    e.preventDefault()
    FirebaseAuth.logout()
  }

  return (
    <div className={styles.header}>
      <div className={styles.headerInner}>
        <div className={styles.logoText}>
          <Link onClick={removeClass} to="/">
            BeepBeep
          </Link>
        </div>
        <div className={styles.center}>
          <nav className={styles.nav}>
            <ul id="nav" className={open && styles.open}>
            <li>
                <Link
                  onClick={removeClass}
                  to="/car-theory-test/1"
                  activeClassName={styles.activeNavLink}
                >
                  Car
                </Link>
              </li>
              <li>
                <Link
                  onClick={removeClass}
                  to="/motorcycle-theory-test/1"
                  activeClassName={styles.activeNavLink}
                >
                  Motorcycle
                </Link>
              </li>
              <li>
                <Link
                  onClick={removeClass}
                  to="/lgv-theory-test/1"
                  activeClassName={styles.activeNavLink}
                >
                  LGV
                </Link>
              </li>
              <li>
                <Link
                  onClick={removeClass}
                  to="/adi-theory-test/1"
                  activeClassName={styles.activeNavLink}
                >
                  ADI
                </Link>
              </li>
              <li>
                <Link
                  onClick={removeClass}
                  to="/hazard-perception-test/1"
                  activeClassName={styles.activeNavLink}
                >
                  Hazard Perception
                </Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className={styles.right}>
        {user ? (
    <ul className={open && styles.open}>
      <li>
      <Link
        onClick={signOut}
        className={styles.defaultBtn}
        to="/"
      >
        Logout
      </Link>
      </li>
    </ul>
  ) : (
    <>
      <ul className={open && styles.open}>
        <li>
          <Link
            onClick={removeClass}
            to="/login/"
            activeClassName={styles.activeNavLink}
          >
            Log in
          </Link>
        </li>

        <li>
          <Link
          className={styles.defaultBtn}
            onClick={removeClass}
            to="/register/"
          >
            Sign up
          </Link>
        </li>
      </ul>
    </>
  )}
        </div>
        <button
            id="icon"
            className={`${styles.dropBtn} ${open && styles.open}`}
            onClick={toggleClass}
          >
            <span className={styles.icon}></span>
        </button>
      </div>
    </div>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
